import {
  GroupedBotProperty,
  PropertyFieldType,
} from '../../../../../../../../../../BotProperties/components/Properties/types'
import { PropertyConditionAction } from '../../../../logic/ConditionTypes/PropertyCondition'

export const getCompatibleConditions = (property: GroupedBotProperty): Array<PropertyConditionAction> => {
  switch (property.type) {
    case PropertyFieldType.String:
    case PropertyFieldType.Email:
    case PropertyFieldType.Phone:
    case PropertyFieldType.URL:
      return [
        PropertyConditionAction.Equals,
        PropertyConditionAction.EndsWith,
        PropertyConditionAction.StartsWith,
        PropertyConditionAction.Contains,
        PropertyConditionAction.IsSet,
        PropertyConditionAction.IsNotSet,
      ]
    case PropertyFieldType.Number:
    case PropertyFieldType.Double:
    case PropertyFieldType.DateTime:
    case PropertyFieldType.Date:
    case PropertyFieldType.Time:
      return [
        PropertyConditionAction.More,
        PropertyConditionAction.Less,
        PropertyConditionAction.MoreOrEquals,
        PropertyConditionAction.LessOrEquals,
        PropertyConditionAction.Equals,
        PropertyConditionAction.BetweenProperty,
        PropertyConditionAction.IsSet,
        PropertyConditionAction.IsNotSet,
      ]
    case PropertyFieldType.Flag:
      return [
        PropertyConditionAction.FlagProp,
        PropertyConditionAction.True,
        PropertyConditionAction.False,
        PropertyConditionAction.IsSet,
        PropertyConditionAction.IsNotSet,
      ]
    case PropertyFieldType.Files:
      return [
        PropertyConditionAction.IsSet,
        PropertyConditionAction.IsNotSet,
      ]
  }
}
